import type { CellMark } from "./types";

export const COLUMN_LETTERS = (col: number) => {
  let value = "";
  let n = col;
  while (n > 0) {
    const remainder = (n - 1) % 26;
    value = String.fromCharCode(65 + remainder) + value;
    n = Math.floor((n - 1) / 26);
  }
  return value;
};

export const coordKey = (row: number, col: number) => `${row}:${col}`;

export const markSet = (
  pairs: [number, number][] | undefined,
  mark: CellMark,
  into: Map<string, CellMark>,
) => {
  for (const [row, col] of pairs ?? []) into.set(coordKey(row, col), mark);
  return into;
};

/** A1-style address, the way a spreadsheet names a cell. */
export const cellAddress = (row: number, col: number) =>
  `${COLUMN_LETTERS(col)}${row}`;

export const MARK_LABEL: Record<CellMark, string> = {
  changed: "Value changed",
  added: "Added",
  removed: "Removed",
  format: "Formatting only",
};

/** How the legend counts each kind of change. */
export const markCount = (mark: CellMark, count: number) => {
  const cells = count === 1 ? "cell" : "cells";
  if (mark === "changed")
    return `${count} ${count === 1 ? "value" : "values"} changed`;
  if (mark === "format") return `${count} ${cells} reformatted`;
  return `${count} ${cells} ${mark}`;
};
